import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example
    { path: '', pathMatch: 'full', redirectTo: 'home' },

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'home' },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes') },
            { path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes') },
            { path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes') },
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes') },
            { path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes') }
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
            { path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes') },
            
            
        ]
    },


    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: 'home', loadChildren: () => import('app/components/home/home.module').then((m) => m.HomeModule)},
            { path: 'metricas', loadChildren: () => import('app/components/metrics/metrics.module').then((m) => m.MetricsModule)},
            { path: 'reports', loadChildren: () => import('app/components/reports/reports.module').then((m) => m.ReportsModule)},
            { path: 'alerts', loadChildren: () => import('app/components/alert/alert.module').then((m) => m.AlertModule)},
            { path: 'trucks', loadChildren: () => import('app/components/trucks/trucks.module').then((m) => m.TrucksModule)}
        ]
    }
];


// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
// export const appRoutes: Route[] = [
//     // Redirect empty path to 'home'
//     { path: '', pathMatch: 'full', redirectTo: 'home' },

//     // Redirect signed-in user to 'home'
//     { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'home' },

//     // Routes for guests (if you still need them)
//     {
//         path: '',
//         component: LayoutComponent,
//         data: { layout: 'empty' },
//         children: [
//             { path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes') },
//             { path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes') },
//             { path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes') },
//             { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes') },
//             { path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes') }
//         ]
//     },

//     // Routes for authenticated users (without guard)
//     {
//         path: '',
//         component: LayoutComponent,
//         data: { layout: 'empty' },
//         children: [
//             { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
//             { path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes') },
//         ]
//     },

//     // Admin routes (without guard for home)
//     {
//         path: '',
//         component: LayoutComponent,
//         resolve: { initialData: initialDataResolver },
//         children: [
//             { path: 'home', loadChildren: () => import('app/components/home/home.module').then((m) => m.HomeModule) },
//             { path: 'reports', loadChildren: () => import('app/components/reports/reports.module').then((m) => m.ReportsModule) },
//         ]
//     }
// ];
